import { initializeApp } from "firebase/app";
import {
  initializeAuth,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBDq-L0P_bGlmpV5pp4lBNEWupV5Rps7XM",
  authDomain: "photo-site-247fd.firebaseapp.com",
  projectId: "photo-site-247fd",
  storageBucket: "photo-site-247fd.firebasestorage.app",
  messagingSenderId: "582222539983",
  appId: "1:582222539983:web:ade6a0394810cda1095bba",
  measurementId: "G-W7N18Z38DC",
};

const app = initializeApp(firebaseConfig);

export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
});

export const db = getFirestore(app);

export const storage = getStorage(app);

export default app;